export default function initVideoControls() {
  setTimeout(function() {
    // Select both hero-media and page-header-hero-media groups.
    var videoGroups = document.querySelectorAll('.hero-media, .page-header-hero-media, .page-header-form-media');

    videoGroups.forEach(function(group) {
      var video = group.querySelector('.video');
      var button = group.querySelector('.btn-video-controller');
      var controlAnnouncements = group.querySelector('.control-announcements');

      // Check if all necessary elements are present
      if (!video || !button || !controlAnnouncements) {
        return;
      }

      // Set up video controls on click or tap.
      button.addEventListener('click', function() {
        var icon = button.querySelector('.icon-play-pause');
        if (!video.paused) {
          video.pause();
          button.setAttribute('aria-label', 'Play video');
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
          controlAnnouncements.textContent = 'Video paused';
        } else {
          video.play();
          button.setAttribute('aria-label', 'Pause video');
          icon.classList.remove("fa-play");
          icon.classList.add("fa-pause");
          controlAnnouncements.textContent = 'Video playing';
        }
      });
    });
  }, 800); // waiting 800ms for Font Awesome to finish icon replacement.
}

export function initVideoModal() {

  document.querySelectorAll('.modal').forEach(function(modal) {
    modal.addEventListener('hidden.bs.modal', function(event) {
        const iframes = modal.querySelectorAll('iframe');
        iframes.forEach(function(iframe) {
            const src = iframe.src;
            iframe.src = "";
            iframe.src = src;
        });
    });
  });


}